module.exports = __webpack_public_path__ + "static/media/fruits_4.2c9e4e6e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_4.csv
// module id = 706
// module chunks = 0